module.exports = __webpack_public_path__ + "img/success.f7659385.svg";